let elements = {
  /**direction type:
  auto
  top
  bottom
  left
  right
  topleft
  topright
  bottomleft
  bottomright
  lefttop
  leftbottom
  righttop
  rightbottom
  **/

  mainImage: {
    imagePath: 'games/page051_game10/img/bcg.jpg',
    width: 1660,
    height: 716,
    pos: {
      x: 109,
      y: 188,
    },
  },
  activeArea: {
    width: 50,
    height: 50,
    fontSize: 35,
    backgroundColor: '#f36f1a',
    color: '#ffffff',
  },
  items: [
    {
      id: '1',
      animation: true,
      // direction: 'left',
      textObj: {
        text: 'Kliknij w kategorię <i>Zdarzenia</i>.',
      },
      audio: {
        src: 'games/page051_game10/audio/z25s51-1.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 214,
        y: 642,
      },
    },
    {
      id: '2',
      // direction: 'left',
      textObj: {
        text: 'Przeciągnij bloczek <i>Kiedy kliknięto.</i>',
      },
      audio: {
        src: 'games/page051_game10/audio/z25s51-2.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 994,
        y: 458,
      },
    },
  ],
};
export default elements;
